import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { TableModule } from 'primeng/table';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';

import { CustRegComponent } from './cust-reg/cust-reg.component';
import { BioGroupProdsComponent } from '../bio-group-prods/bio-group-prods.component';
import { HomeComponent } from '../home/home.component';




export const routes: Routes = [
  { path: 'Home', component: HomeComponent, data: { breadcrumb: 'Home' } },
  { path: 'Customers', component: CustRegComponent, data: { breadcrumb: 'Customers' } },
     
]

@NgModule({
  declarations: [CustRegComponent],
  imports: [
    CommonModule, RouterModule.forChild(routes), TableModule, FormsModule, TabViewModule,
  ]
})
export class AdminModule { }
